import React from "react";
import { Badge, Icon } from "@chakra-ui/react";
import { MdCheckCircle, MdError } from "react-icons/md";

/**
 * Renders a small Badge with a check or error icon reflecting a boolean status.
 * @param {object} props
 * @param {boolean} props.isActive - Whether the status is positive
 * @param {string} props.activeLabel - Label when active (e.g. "Connected")
 * @param {string} props.inactiveLabel - Label when inactive (e.g. "Disconnected")
 * @returns {React.ReactElement}
 */
function StatusChipIndicator({ isActive, activeLabel, inactiveLabel }) {
    return (
        <Badge colorScheme={isActive ? "green" : "red"} borderRadius="6px"
            display="inline-flex" alignItems="center" gap="4px" px="8px" py="2px" fontWeight="600">
            <Icon as={isActive ? MdCheckCircle : MdError} w="12px" h="12px" />
            {isActive ? activeLabel : inactiveLabel}
        </Badge>
    );
}

export default StatusChipIndicator;
